module.exports = __webpack_public_path__ + "static/messages_florball-ffca15bb0e119558bd9c155f1b8f05e9.mp4";